var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page__footer"},[_c('hr',{staticClass:"footer__divider"}),_c('div',{staticClass:"footer__content"},[_c('div',[_vm._v(" "+_vm._s(_vm.$t('report.footer.copyrightNotice'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }